const ReactDataGrid = require('react-data-grid');
const React = require('react');
import ReactDOM from 'react-dom';

import Command from "../remote/Command";
import ServiceHelper from "../remote/ServiceHelper";

import Warning from "../utils/Warn";
import Fade from '../utils/Fade';
import ArrayUtil from '../utils/ArrayUtil';

export default class CurrentRecordInfo extends React.Component {
  constructor(props) {
    super(props);
    
    this.isAdmin = window.parent.window.userInfos.isAdmin;
    // var rows=this.props.rows;
    if(this.isAdmin){
      var columns=[
      {
        key: 'dataSourceEnLabel',
        name: "数据源",
        width: 137,
        resizable: true
      },
      {
        key: 'chLabel',
        name: "中文名",
        width: 137,
        resizable: true
      },
      {
        key: 'enLabel',
        name: "英文名",
        width:150,
        resizable: true
      },
      {
        key: 'fvalue',
        name: "值",
        width:136,
        resizable: true
      }];
    }else{
      var columns=[{
        key: 'chLabel',
        name: "中文名",
        width: 205,
        resizable: true
      },
      {
        key: 'fvalue',
        name: "值",
        width:205,
        resizable: true
      }];
    }
    let initSelectIndex = 0;
    let currentEnLabel=this.props.parms?this.props.parms.field:"";
    if(currentEnLabel)
    {
      let rowsLength = this.props.fdataProvider?this.props.fdataProvider.length:0;
      for(let i = 0;i<rowsLength;i++)
      {
        let row = this.props.fdataProvider[i];
        if(row.enLabel == currentEnLabel)
        {
          initSelectIndex = i;
          break;
        }
      }
    }
    this.columns = columns;
    this.state ={
      rows:this.props.fdataProvider, 
      selectedIndexes: [initSelectIndex],
      fdataProvider: {},
      title: this.props.title,
      _tabName: this.props.tableName,
      _group: this.props.self
    }

    this.GlobalValueRepalceSelectItem = null;
    this.GlobalValueRepalceSelectTitle = null;

    this.RefResultList = null;
    
  }
  static instance;
  static instance;

  static show(fdataProvider, tableName, self, title,parms={}) {
    if (CurrentRecordInfo.instance == null) {

      CurrentRecordInfo.instance = ReactDOM.render(
        
        <CurrentRecordInfo fdataProvider={fdataProvider} tableName={tableName} self={self} title={title} parms={parms} />
        
        ,document.getElementById('currentRecordInfoModal')
      )
      
      
        
    }else{
      
      /*let origRows = CurrentRecordInfo.instance.state.rows;
      //let selectedIndex = CurrentRecordInfo.instance.state.selectedIndexes?CurrentRecordInfo.instance.state.selectedIndexes[0]:null;
      //if(!selectedIndex)selectedIndex = 0;
      let origRecId;
      for(let i = 0;i<origRows.length;i++)
      {
        let origRow = origRows[i];
        if(origRow.enLabel == "RecId")
        {
          origRecId = origRow.fvalue;
          break;
        }
      }

      let nowRecId;
      for(let i = 0;i<fdataProvider.length;i++)
      {
        let row = fdataProvider[i];
        if(row.enLabel == "RecId")
        {
          nowRecId = row.fvalue;
          break;
        }
      }

      if(origRecId && nowRecId == origRecId)
      {
        CurrentRecordInfo.instance.setState({
          rows:fdataProvider,
          title:title,
          _tabName : tableName,
          _group:self
        });
      }
      else
      {
        CurrentRecordInfo.instance.setState({
          rows:fdataProvider,
          title:title,
          _tabName : tableName,
          _group:self,
          selectedIndexes:[0]
        });
      }*/

      let initSelectIndex = 0;
      let currentEnLabel=parms?parms.field:"";
      if(currentEnLabel)
      {
        let rowsLength = fdataProvider?fdataProvider.length:0;
        for(let i = 0;i<rowsLength;i++)
        {
          let row = fdataProvider[i];
          if(row.enLabel == currentEnLabel)
          {
            initSelectIndex = i;
            break;
          }
        }
      }

      CurrentRecordInfo.instance.setState({
        rows:fdataProvider,
        title:title,
        _tabName : tableName,
        _group:self,
        selectedIndexes: [initSelectIndex]
      });
      $("#currentRecordInfoModal").css("display","flex");


      /*let selectedIndex = CurrentRecordInfo.instance.state.selectedIndexes?CurrentRecordInfo.instance.state.selectedIndexes[0]:null;
      if(!selectedIndex)selectedIndex = 0;
      CurrentRecordInfo.instance.grid.doOnSelect({rowIdx:selectedIndex,idx:0,active:false});
  
      var selectedCells = $(CurrentRecordInfo.instance.gridContainer).find(".react-grid-Cell.row-selected");
      if(selectedCells.length==0)
       return;
      selectedCells[0].focus();*/
      
    }
  }
  componentDidMount(){
    $(this.CurrentRecordInfoModalContainer).draggable({
      handle: ".modal-header", // 只能点击头部拖动
      cancel: "div.modal-header-only-title"
    }); //为模态对话框添加拖拽

    $(this.RecordRefViewModal_Container).draggable({
      handle: ".modal-header" // 只能点击头部拖动
    }); //为模态对话框添加拖拽
 
    $(this.GlobalValueRepalceModal_Container).draggable({
      handle: ".modal-header" // 只能点击头部拖动
    }); //为模态对话框添加拖拽
    $("#currentRecordInfoModal").css("display","flex");
   
   
    /*let selectedIndex = this.state.selectedIndexes?this.state.selectedIndexes[0]:null;
    if(!selectedIndex)selectedIndex = 0;
    this.grid.doOnSelect({rowIdx:selectedIndex,idx:0,active:false});

    var selectedCells = $(this.gridContainer).find(".react-grid-Cell.row-selected");
    if(selectedCells.length==0)
     return;
    selectedCells[0].focus();

    this.GlobalValueRepalceSelectItem = this.state.rows[selectedIndex];*/
  }

  hideCurrentRecordInfo=()=>{
    $("#currentRecordInfoModal").css("display","none");
  }

  btnCopy_clickHandler = () =>{
    var items = this.state.rows;
    var columns = this.columns;
    var CopyData = "";
    if(this.isAdmin)
    {
      CopyData = CopyData+columns[0].name + "\t" + columns[1].name + "\t" + columns[2].name + "\t"+columns[3].name + "\n";
    }else {
      CopyData = CopyData+columns[1].name + "\t" + columns[3].name + "\n";
    }
    
    if(this.isAdmin)
    {
      items.map((item)=>{
        CopyData = CopyData+item.dataSourceEnLabel+"\t"+item.chLabel + "\t" + item.enLabel + "\t" + item.fvalue + "\n";
      })
    }
    else
    {
      items.map((item,i)=>{
        CopyData = CopyData+item.chLabel + "\t" + item.fvalue + "\n";
      })
    }
    this.doCopy(CopyData);
  }

  btnCopyItem_clickHandler = () =>
  {
    var columns = this.columns;
    var CopyData="";
    if (this.isAdmin) 
    {
      CopyData = CopyData + columns[0].name + "\t" + columns[1].name + "\t" + columns[2].name + "\t"+columns[3].name + "\n";
    } 
    else 
    {
      CopyData = CopyData + columns[1].name + "\t" + columns[3].name + "\n";
    }
    
    for(let i = 0;i<this.state.selectedIndexes.length;i++)
    {
      let _selectedIndex = this.state.selectedIndexes[i];
      let item = this.state.rows[_selectedIndex];
      if(this.isAdmin)
      {
          CopyData = CopyData+item.dataSourceEnLabel+"\t"+item.chLabel + "\t" + item.enLabel + "\t" + item.fvalue + "\n";
      }
      else
      {
          CopyData = CopyData+item.chLabel + "\t" + item.fvalue + "\n";
      }
    }

    this.doCopy(CopyData);
  }

  doCopy = (txt) =>
  {
    var tag = document.createElement('textarea');
    tag.setAttribute('id', 'cp_hgz_input');
    tag.value = txt;
    document.getElementsByTagName('body')[0].appendChild(tag);
    document.getElementById('cp_hgz_input').select();
    document.execCommand('copy');
    document.getElementById('cp_hgz_input').remove();

    if (tag) {
      $(this.CopyModalContainer).css("display", "none");
      Fade.show({
        text:"复制成功"
      });
    }
  }

  hideCopyModal =() =>{
    $(this.CopyModalContainer).css("display","none");
  }




  btnRef_clickHandler = () =>{
    this.GlobalValueRepalceSelectItem = this.getCurrentRecord();
    if(this.GlobalValueRepalceSelectItem == null)
      return;
    var command = Command.createService( "gongqi.erp.gotmodel.services.MixedService", "listRecordRef", "List");
    var recId;
    var dgData = this.state.rows;
    dgData.map((item)=>{
      if(item.enLabel == "RecId"){
        recId = item.fvalue;
      }
    });
    var _tableName = this.state._tabName;
    command.appendArg(_tableName);
    command.appendArg(recId);
    command.appendArg(this.GlobalValueRepalceSelectItem.enLabel);
    ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.refResultHandler.bind(this)});
  }

  refResultHandler = (event) =>{
    if(event.result == null || event.result.length==0)
				{
          // alert("无引用关系","提示");
          Warning.show({
            text: "无引用关系",
            title: "提示"
          });
				}
				else
				{
          // this.RefResultList = event.result;
          var items = event.result;
          $(this.RefListBody).empty();
          items.map((item)=>{
             $(this.RefListBody).append(
              "<li style='line-height:30px;line-style:none;width:100%;border-bottom:1px solid #f3f3f3;'>"+ item +"</li>"
             );
          })
          $(this.RecordRefViewModalContainer).css("display","block");
				}
  }

  btnRequire_clickHandler(){
    $(this.RecordRefViewModalContainer).css("display","none");
  }

  btnGlobalValueRepalce_clickHandler = ()=>{    
    this.GlobalValueRepalceSelectItem = this.getCurrentRecord();
    if(this.GlobalValueRepalceSelectItem == null)
      return;
    
    $(this.GlobalValueRepalceModalContainer).css("display","block");
    let rows = this.state.rows;
    let selectedIndex;

    if(this.state.selectedIndexes && this.state.selectedIndexes.length>0)
      selectedIndex = this.state.selectedIndexes[this.state.selectedIndexes.length-1];

    if(selectedIndex==-1 || !rows)
      return;
    if(rows[selectedIndex])
    {
      $(this.GlobalValueRepalceModal_title).html(rows[selectedIndex].chLabel);
      $(this.doRepalceValue).val(rows[selectedIndex].fvalue).focus().select();
    }
      
  }

  hideGlobalValueRepalce = ()=>{

    $(this.GlobalValueRepalceModalContainer).css("display","none");

  }

  getCurrentRecord = () =>
  {
    let selectedIndex = this.state.selectedIndexes?this.state.selectedIndexes[0]:-1;
    if(selectedIndex > -1)
    {
      return this.state.rows[selectedIndex];
    }
    return null;
  }

  saveGlobalValueRepalce = ()=>{

    this.GlobalValueRepalceSelectItem = this.getCurrentRecord();

    if(this.GlobalValueRepalceSelectItem == null)
      return;
    var value = $(this.doRepalceValue).val();
    var command = Command.createService("gongqi.erp.gotmodel.services.MixedService", "updateRecordRef", "List");
    var recId = null;
    var dataSourceMain = this.GlobalValueRepalceSelectItem.dataSourceEnLabel;
    var dgData = this.state.rows;
    dgData.map((item)=>{
      if(item.enLabel == "RecId" && item.dataSourceEnLabel == dataSourceMain){
        recId = item.fvalue;
      }
    });
    var _tableName = this.state._tabName;
    command.appendArg(_tableName);
    command.appendArg(recId);
    command.appendArg(this.GlobalValueRepalceSelectItem.enLabel);
    command.appendArg(value);
    var self =this;
    var remoteArg = {
      command: command,
      resultFunction: self.refUpdateResultHandler.bind(this,value),
      faultFunction: self.refUpdateFaultHandler.bind(this)
    };
    ServiceHelper.addTokenWithCommand(remoteArg);
    // ServiceHelper.addTokenWithCommand({
    //   command: command,
    //   resultFunction: self.refUpdateResultHandler.bind(this,result,value), 
    //   faultFunction: self.refUpdateFaultHandler.bind(this)
    // });
  }
  refUpdateResultHandler(value,event) {
    if(event.result == null || (event.result).length==0)
				{
          // alert("无结果返回!您可能替换的不是业务主键");
          $(this.GlobalValueRepalceModalContainer).css("display","none");
          Warning.show({
            text: "无结果返回!您可能替换的不是业务主键",
            title: "提示",
            confirm:{
              isShow:true,
              event:this.btnGlobalValueRepalce_clickHandler.bind(this)
            },
          });
				}
				else
				{
				  $(this.GlobalValueRepalceModalContainer).css("display", "none");
          var items = event.result;
          $(this.RefListBody).empty();
          items.map((item) => {
            $(this.RefListBody).append(
              "<li style='line-height:30px;line-style:none;width:100%;border-bottom:1px solid #f3f3f3;'>" + item + "</li>"
            );
          })
          $(this.RecordRefViewModalContainer).css("display", "block");
          // RecordRefView.Instance.show(IList(event.result));
          let rows = this.state.rows;
          let _clickIndex;
          if(this.state.selectedIndexes && this.state.selectedIndexes.length>0)
            _clickIndex = this.state.selectedIndexes[this.state.selectedIndexes.length-1]
          let selectedIndexes = _clickIndex?_clickIndex:0;
          rows[selectedIndexes].fvalue = value;
          this.setState({
            rows:rows
          });
          this.state._group.doRecordRestore(false,true,false);
				}
  }

  refUpdateFaultHandler = (event) => {
    if(event && event.successButNot0)
    {
       Warning.show({text:event.errText,title:"替换失败"});
       return;
    }
    
    var faultString = "";
    var rootCause = event.fault.rootCause;
    if(rootCause!=null && rootCause.hasOwnProperty("message"))
    {
      var errorCode = rootCause["errorCode"];
      if(errorCode == "hibernate.ConstraintViolationException")
      {
        var message = rootCause["message"];
        if(message.indexOf("Duplicate entry") == 0)
        {
          faultString = "存在重复的键值，不允许修改";
        }
      }
      else if(errorCode=="hibernate.StaleObjectStateException")
      {
        faultString = "当前记录状态已不是最新或者已被删除，请执行恢复记录操作";
      }
      
      if(faultString == "")
        faultString = rootCause["message"];
    }
    else
    {
      faultString = event.fault.faultString;
    }
    
    if(faultString.indexOf("#NotNull:")==0)
    {
      faultString = "值不能为空，不允许修改";
    }
    
    //GongqiAlert.show(faultString,"保存操作由于以下原因未成功");
    // alert(faultString,"全局替换操作由于以下原因未成功");
    Warning.show({
      text: faultString + "无结果返回!您可能替换的不是业务主键"
    });
  }



  /**datagrid */
  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    let rows = this.state.rows.slice();

    for (let i = fromRow; i <= toRow; i++) {
      let rowToUpdate = rows[i];
      let updatedRow = $.extend(rowToUpdate,updated);
      rows[i] = updatedRow;
    }
    this.setState({ rows:rows});
  };
  getRowAt = (index) => {
    if (index < 0 || index > this.getSize()) {
      return undefined;
    }

    return this.state.rows[index];

  };

  getSize = () => {
    return this.state.rows.length;
  };

  gridKeyDown(proxy)
  {
    //console.log(arguments);
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];
     
      if(ne.keyCode == 40 || ne.keyCode == 38)
      {
        let record = null;
        var newSelectIndexes = this.state.selectedIndexes.slice();
        if(newSelectIndexes.length == 0)
        {
          if(this.state.rows.length>0)
          {
            record = ne.keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
            newSelectIndexes.push(0);
            this.setState({selectedIndexes:newSelectIndexes});
          }
        }
        else
        {
          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
          let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
          let total = this.state.rows.length;
          if(newIndex>=0&&newIndex<total)
          {
            record = this.state.rows[newIndex];
            newSelectIndexes = [newIndex];
            this.setState({selectedIndexes:newSelectIndexes});
          }
        }
        
        return true;
      }
     
    }
  }

  rowClick(index,record,proxy)
  {
    if(index==-1)
      return;
    var newSelectIndexes;
  
    if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
    {
      let ne = proxy["nativeEvent"];

      if(ne.shiftKey)
      {
        //let origSelectIndexes = this.state.selectedIndexes;
        if(this.state.selectedIndexes.length>0)
        {
          newSelectIndexes = this.state.selectedIndexes.slice();
          let minIndex = newSelectIndexes[0];let maxIndex = newSelectIndexes[0];
          for(var i in newSelectIndexes)
          {
            if(newSelectIndexes[i]>maxIndex)maxIndex = newSelectIndexes[i];
            if(newSelectIndexes[i]<minIndex)minIndex = newSelectIndexes[i];
          }

          if(index>maxIndex)
          {
            for(i=maxIndex+1;i<=index;i++)
              newSelectIndexes.push(i);
          }
          else if(index<minIndex)
          {
            for(i=minIndex-1;i>=index;i--)
              newSelectIndexes.push(i);
          }
          else
          {
            if(newSelectIndexes.indexOf(index)==-1)
            {
              let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
              newSelectIndexes.push(index);
              for(i=0;i<Math.abs(index-lastIndex);i++)
              {
                if(index<lastIndex)
                {
                  newSelectIndexes.push(index+i);
                }
                else if(lastIndex>index)
                {
                  newSelectIndexes.push(lastIndex+i);
                }
              }
            }
          }
        }
        else
        {
          newSelectIndexes.push(index);
        }
      }
      else if(ne.ctrlKey)
      {
        newSelectIndexes = this.state.selectedIndexes.slice();
        if(newSelectIndexes.indexOf(index)==-1)
        {
          newSelectIndexes.push(index);
        }
        else
        {
          ArrayUtil.removeByValue(newSelectIndexes,index);
        }
        //禁止完全取消选中 因为很多功能流程都依赖于选中项 如果去掉可能造成很多不可预知的bug 如保存记录时recId重复
        //新增记录 然后取消选中 换行 此时会导致保存成功 但是DataGrid控件并没有把保存成功的记录更新到状态因为已没有选中项
        if(newSelectIndexes.length==0)
          newSelectIndexes = [index];
      }
      else
      {
        newSelectIndexes = [index];
      }
    }
    else
    {
      newSelectIndexes = [index];
    }

    
    
    this.setState({selectedIndexes:newSelectIndexes});  
    
    
    this.GlobalValueRepalceSelectTitle = record.chLabel;
    this.GlobalValueRepalceSelectItem = record;
  }

  render() {  

    let globalReplaceDisplay = "none";

    if(window.parent && window.parent.window)
    {
      if(window.parent.window.userInfos && window.parent.window.userInfos.isAdmin)
      {
        globalReplaceDisplay = "block";
      }
    }
    var _parentWindow = (typeof(window.openMenuItem) == 'function')?window:window.parent.window;
    return (
          <div ref={node=>this.CurrentRecordInfoModalContainer=node} tabIndex="-1"  style={{position:'absolute',alignSelf:"center",borderRadius:"2px",backgroundColor:'white',width:'800px',height:'500px',display:'flex',flexDirection:'column',background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)'}}>
          <div className="modal-header" style={{position:"relative"}}>
            <div className="modal-close" onClick={this.hideCurrentRecordInfo.bind(this)}></div>
            <h5 className="modal-title"><div className="modal-header-only-title" style={{float:"left",userSelect:"text"}}>{this.state.title}</div></h5>
          </div>
          <div style={{display:'flex',flexDirection:'column',flexGrow:100}}>
              <div style={{display:'flex',flexDirection:'row',flexGrow:100,borderRadius:'3px',padding:'14px'}}>
                <div style={{display:'flex',flexDirection:'column',flexGrow:100}} ref={node=>this.gridContainer=node}>
                  {/* <CurrentRecordInfoReactDataGrid  ref={node=>this.DataGrid=node} /> */}
                  <ReactDataGrid        
                    ref={ node => this.grid = node }
                    // onGridSort={this.handleGridSort}
                    enableCellSelect={true}
                    columns={this.columns}//columns={this.state.columns}
                    // columns={this.props.columns}
                    // columns={this.getColumns()}
                    rowGetter={this.getRowAt}
                    rowsCount={this.getSize()}
                    onGridRowsUpdated={this.handleGridRowsUpdated}
                    // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
                    enableRowSelect={false}
                    onGridKeyDown={this.gridKeyDown.bind(this)}
                    
                    rowSelection={{
                      showCheckbox: false,
                      selectBy: {
                        indexes: this.state.selectedIndexes
                        
                      }
                    }}
                    onRowClick={this.rowClick.bind(this)}//this.rowClick this.rowClick.bind(this)
                    rowHeight={30}
                    minHeight={240}
                    rowScrollTimeout={500} 
                    cellNavigationMode="loopOverRow"
                    
                    />
                </div>
              </div>
              <div style={{display:'flex',flexDirection:'horizontal',flexGrow:0,padding:'9px 9px',overflow:'auto',borderTop:'1px solid rgba(0,0,0,0.10)',paddingLeft:'13px'}}>
                <button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.btnCopy_clickHandler.bind(this)} style={{marginLeft:'0px',marginRight:'0',padding:'5px 12px !important'}}>复制到剪贴板</button>
                <button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.btnCopyItem_clickHandler.bind(this)} style={{marginLeft:'5px',marginRight:'0',padding:'5px 12px !important'}}>复制选中行到剪贴板</button>
                <button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.btnRef_clickHandler.bind(this)} style={{marginLeft:'5px',marginRight:'0'}}>查看引用列表</button>
                <button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.btnGlobalValueRepalce_clickHandler.bind(this)} style={{marginLeft:'5px',marginRight:'0',display:globalReplaceDisplay}}>全局替换</button>
              </div>
          </div>

         

          <div className="modal" ref={node=>this.RecordRefViewModalContainer=node} style={{zIndex: '2000',display:'none'}}>
            <div className="modal-dialog" style={{marginTop:'100px',width:'400px'}}>
                <div className="modal-content" ref={node=>this.RecordRefViewModal_Container = node} style={{background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
                  <div id="RecordRefViewModal_Container_Header" className="modal-header">
                    <div className="modal-close" onClick={this.btnRequire_clickHandler.bind(this)}></div>
                    <span className="modal-title" style={{marginTop:'0',marginBottom:'0',fontSize:'16px'}}>记录引用关系</span>
                  </div>
                  <div ref={node=>this.RefSuccessList = node} className="modal-body" style={{display:'flex',flexDirection:'row',padding:'10px 5px'}} >
                      <ul ref={node=>this.RefListBody =node} style={{width:'100%',padding:'0 10px',height:'200px',overflow:'auto',margin:'0'}}>
                         
                      </ul>
                  </div>
                  <div className="modal-footer" style={{padding:'5px 15px'}} >
                    <button type="button" className="btn btn-primary" style={{width:'80px',height:'28px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',color:'#FFFFFF',letterSpacing:0,textAlign:'center',lineHeight:'10px',border:'1px solid #f5a623',backgroundColor:'#f5a623'}} onClick={this.btnRequire_clickHandler.bind(this)}>确定</button>
                  </div>
                </div>
            </div>
          </div>

          <div className="modal" ref={node=>this.GlobalValueRepalceModalContainer=node} style={{zIndex: '2000',display:'none'}}>
              <div className="modal-dialog" style={{marginTop:'100px',width:'550px'}}>
                    <div className="modal-content" ref={node=>this.GlobalValueRepalceModal_Container=node} style={{background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
                      <div className="modal-header">
                        <div className="modal-close" onClick={this.hideGlobalValueRepalce.bind(this)}></div>
                        <span className="modal-title" ref={node=>this.GlobalValueRepalceModal_title=node} style={{marginTop:'0',marginBottom:'0',fontSize:'16px'}}></span>
                      </div>
                      <div className="modal-body" style={{display:'flex',flexDirection:'row',padding:'20px 23px'}} >
                        <div style={{flexGrow:1,textAlign:'center'}} >
                          <div style={{display:'flex',flexDirection:'row'}}>
                            <div style={{flexGrow:0,textAlign:'right'}} >
                              <label style={{paddingTop:'4px',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',textAlign:'right',fontWeight:500}} >请输入新值：</label> 
                            </div>
                            <div style={{flexGrow:1,textAlign:'left'}}>
                              <input ref={node=>this.doRepalceValue = node} type="text" spellCheck="false" className="form-control" style={{width:'250px',height:'28px',borderRadius:'4px'}} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer" style={{padding:'10px 15px'}} >
                        <button type="button" className="btn" data-dismiss="modal" onClick={this.hideGlobalValueRepalce.bind(this)} style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}}>取消</button>
                        <button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px'}} onClick={this.saveGlobalValueRepalce.bind(this)}>确认</button>
                      </div>
                    </div>
                </div>
            </div>
    </div>);

  }
}



// WEBPACK FOOTER //
// ./src/currentRecordInfo/CurrentRecordInfo.js